import { Fragment, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { HStack, Tooltip, Text, Button } from '@library';
import styles from './SparePartsSkuList.module.scss';

const SparePartsSkuList = memo(
    ({
        skuList,
        inline,
        limit = 7,
    }: {
        skuList: string[];
        inline?: boolean;
        limit?: number;
    }) => {
        if (skuList.length === 0) {
            return <>-</>;
        }

        const [firstFew, others] = [
            skuList.slice(0, limit),
            skuList.slice(limit),
        ];

        return (
            <HStack wrap>
                {firstFew.map((item, index) => {
                    return (
                        <Fragment key={item}>
                            <div>{item}</div>
                            {index !== firstFew.length - 1 && <>,&nbsp;</>}
                        </Fragment>
                    );
                })}

                {others.length > 0 && inline && <>,&nbsp;</>}

                {others.length > 0 && (
                    <Tooltip
                        mode="click"
                        content={
                            <div className={styles.tooltipSkuList}>
                                <HStack wrap gap="mini">
                                    {others.map(item => (
                                        <Text secondary regular key={item}>
                                            {item}
                                        </Text>
                                    ))}
                                </HStack>
                            </div>
                        }
                        showArrow
                    >
                        <div className={!inline ? styles.block : ''}>
                            <Button text inline>
                                <Text secondary>
                                    <FormattedMessage
                                        id="+{count} more"
                                        values={{ count: others.length }}
                                    />
                                </Text>
                            </Button>
                        </div>
                    </Tooltip>
                )}
            </HStack>
        );
    }
);

export default SparePartsSkuList;
